import { useAuth } from "../../../context/AuthContext";
import React from "react";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./dashboard.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from "../../../components/Button"
import totalEnquiriesImg from "../../../image/totalEnquiries.svg";
import quotationReceivedImg from "../../../image/quotationReceived.svg";
import bookingConfirmedImg from "../../../image/bookingConfirmed.svg";
import lastFiveImg from "../../../image/lastFive.svg";
import pendingShippingImg from "../../../image/pendingShipping.svg";
import quotSentImg from "../../../image/quotSent.svg";
import quotAcceptImg from "../../../image/quotAccept.svg";
import createBlImg from "../../../image/createBl.svg";
import blReceivedImg from "../../../image/blReceived.svg"
import switchBlImg from "../../../image/switchBl.svg";
import quotationPendingImg from "../../../image/quotationPending.svg"
import exportEnquiryImg from "../../../image/exportEnquiry.svg";
import importEnquiryImg from "../../../image/importEnquiry.svg";
import callbackRequestsImg from "../../../image/callbackRequests.svg";
import totalClientImg from "../../../image/totalClient.svg";
import completedBookingImg from "../../../image/completedBooking.svg";
import verifyIcon from "../../../image/verify.png";
import pendingIcon from "../../../image/Pending.png"
import CancelIcon from "@mui/icons-material/Cancel";
import api from "../../../api/api";
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
 
const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
 
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [open, setOpen] = useState(false);
const [kpiData, setKpiData] = useState({});
  
  const inputRef = useRef(null);
 
  //  USER CARDS
  const userBoxData = [
    {
      id: 1,
      heading: "Total Enquiries Submitted",
      image: totalEnquiriesImg,
      key: "user_total_enquiries",
    },
    {
      id: 2,
      heading: "Quotation Received",
      image: quotationReceivedImg,
      key: "user_quotation_received",
    },
    {
      id: 3,
      heading: "Quotation Pending",
      image: quotationPendingImg,
      key: "user_quotation_pending",
    },
    {
      id: 4,
      heading: "Booking Confirmed",
      image: bookingConfirmedImg,
      key: "user_booking_confirmed",
    },
    {
      id: 5,
      heading: "Enquiries (Last 5 Days)",
      image: lastFiveImg,
      key: "user_enquiries_last_5_days",
    },
    {
      id: 6,
      heading: "BL Received",
      image: blReceivedImg,
      key: "user_bl_received",
    },
    {
      id: 7,
      heading: "Pending Shipping Instruction",
      image: pendingShippingImg,
      key: "user_pending_shipping",
    },
    {
      id: 8,
      heading: "Callback Request For Quotation",
      image: callbackRequestsImg,
      key: "user_callback_requests",
    },
  ];
 
  // ======== Sales_Rep Cards ======= //
 
  const salesBoxData = [
 
  {
      id: 1,
      heading: "Total Enquiries",
      image: totalEnquiriesImg,
      className: "icon-red",
      key: "total_enquiries",
    },
 
    {
      id: 2,
      heading: "Quotation Pending",
      image: quotationPendingImg,
      key: "quotation_pending",
    },
 
    {
      id: 3,
      heading: " Total Import Enquiries",
      image: importEnquiryImg,
      key: "import_enquiries",
    },
 
     {
      id: 4,
      heading: " Total Export Enquiries",
      image: exportEnquiryImg,
      key: "export_enquiries",
    },
  ];
 
  // ======= ADMIN & SUPERADMIN CARDS ======= //
  const adminBoxData = [
    {
      id: 1,
      heading: "Total Enquiries",
      image: totalEnquiriesImg,
      className: "icon-red",
      key: "total_enquiries",
    },
    {
      id: 2,
      heading: "Quotations Sent",
      image: quotSentImg,
      key: "quotations_sent",
    },
    {
      id: 3,
      heading: "Quotation Accepted",
      image: quotAcceptImg,
      key: "booking_confirmed",
    },
    {
      id: 4,
      heading: "BL Draft Created",
      image: createBlImg,
      key: "bl_created",
    },
    {
      id: 5,
      heading: "Enquiries (Last 5 Days)",
      image: lastFiveImg,
      key: "enquiries_last_5_days",
    },
    {
      id: 6,
      heading: "Switch BL Created",
      image: switchBlImg,
      key: "switch_bl",
    },
    {
      id: 7,
      heading: "Pending Shipping Instruction",
      image: pendingShippingImg,
      key: "pending_shipping",
    },
    {
      id: 8,
      heading: "Quotation Pending",
      image: quotationPendingImg,
      key: "quotation_pending",
    },
    {
      id: 9,
      heading: "Import Enquiries",
      image: importEnquiryImg,
      key: "import_enquiries",
    },
    {
      id: 10,
      heading: "Export Enquiries",
      image: exportEnquiryImg,
      key: "export_enquiries",
    },
    {
      id: 11,
      heading: "Callback Requests",
      image: callbackRequestsImg,
      key: "callback_requests",
    },
    {
      id: 12,
      heading: "Total Clients",
      image: totalClientImg,
      key: "total_clients",
    },
  ];
 
  // ======== WH_OWNER ======= //
   const whownerBoxData = [
    {
       id: 1,
       heading: "Total Requests",
       image:  totalClientImg,
       key: "total_requests",
    },
 
    {
       id: 2,
       heading: "Accepted Requests",
       image: quotAcceptImg,
       key: "accepted_requests",
    },
 
     {
       id: 3,
       heading: "Pending Requests",
       image: pendingShippingImg,
       key: "pending_requests",
    },
    ]

     const whmanagerBoxData = [
  {
    id: 1,
    heading: "Total Bookings",
    image: totalEnquiriesImg,
    key: "total_bookings",
  },
   {
     id: 2,
     heading: "Pending Bookings",
     image: pendingShippingImg,
     key: "pending_bookings",
   },
   {
     id: 3,
     heading: "Completed Bookings",
     image: completedBookingImg,
     key: "completed_bookings",
   },
];
        // ============== CHA Admin ================== //
const chaadminBoxData  = [
{
  id: 1,
  heading: "CHA Bookings",
  image: completedBookingImg,
  key: "cha_bookings",
} 
]; 

const fetchKpis = async (start, end) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        window.location.href = "/login";
        return;
      }

      const params = {};
      if (start && end) {
        params.fromDate = start.toISOString();
        params.toDate = end.toISOString();
      }

      const { data } = await api.get("/dashboard/kpis", {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setKpiData(data);
    } catch (err) {
      console.error("Failed to fetch KPI data:", err.response || err);
    }
  };

  
  
  useEffect(() => {
    fetchKpis();
  }, [user]);
 
const handleFilter = () => {
    if (startDate && endDate) {
      fetchKpis(startDate, endDate);
      setOpen(false);
    }
  };

  const handleClearFilter = () => {
    setDateRange([null, null]);
    setOpen(false);
    fetchKpis();
  };
  const handleToggle = () => {
    setOpen((prev) => !prev);
  };
  if (!user) return <div>Loading...</div>;
 
  const activeBoxData =
  user?.user_role === "Admin" || user?.user_role === "SuperAdmin"
    ? adminBoxData
    : user?.user_role === "sales_rep"
    ? salesBoxData
    : user?.user_role === "wh_owner"
    ? whownerBoxData
     : user?.user_role === "wh_manager"
    ? whmanagerBoxData 
    : user?.user_role === "cha_admin"
    ? chaadminBoxData 
    : user?.profile_status === "Verified"
    ? userBoxData
    : [];
  return (
    <>
      {/* Date Filter */}
      {(user?.user_role === "Admin" || user?.user_role === "SuperAdmin") && (
        <div className="row align-items-center mb-4">
          <div className="col-sm-6 col-md-3">
            <input
              ref={inputRef}
              readOnly
              value={
                startDate && endDate
                  ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                  : ""
              }
              onClick={() => setOpen(!open)}
              placeholder="Select Date Range"
              className="form-control"
            />
            {open && (
              <div className="position-absolute bg-white shadow p-3 rounded mt-1 z-3">
                <DatePicker
                  inline
                  selectsRange
                  monthsShown={2}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => setDateRange(update)}
                  maxDate={new Date()}
                />
                <div className="d-flex justify-content-end mt-2">
                  <Button onClick={handleToggle} text="Done" btncls="me-2" />
                  <Button
                    onClick={handleClearFilter}
                    text="Clear"
                    variant="danger"
                  />
                </div>
              </div>
            )}
          </div>
          <div className="col-sm-6 col-md-4 col-lg-5 col-xl-3 d-flex mt-3 mt-sm-0">
            <Button
              onClick={handleFilter}
              text="Apply Filter"
              btncls="me-2 mt-0 w-100 w-sm-auto"
            />
            <Button
              onClick={handleClearFilter}
              text="Clear Filter"
              variant="danger"
              btncls="mt-0 w-100 w-sm-auto light-red"
            />
          </div>
        </div>
      )}
 
        {/* KPI Cards */}
        <div className="row">
          {activeBoxData.map((box) => (
            <div className="col-sm-6 col-lg-4 col-xl-3 mb-4 d-flex" key={box.id}>
              <div className="mainbox w-100 text-center">
                <div className="icon mb-2">
                  <img
                    src={box.image}
                    alt={box.heading}
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>
                <div>
                  <h2 className="mb-2">{box.heading}</h2>
                  <h3>{kpiData[box.key] ?? 0}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>



      {/* Verification Card for Unverified Users */}
      {user?.user_role === "User" && user?.profile_status === "Unverified" && (
        <div className="row justify-content-center">
          <div className="col-sm-6 col-lg-4 col-xl-4 mb-4 d-flex">
            <div
              className="mainbox w-100 text-center"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/user-profile")}
            >
              <div className="icon mb-2">
                <img
                  src={verifyIcon}
                  alt="Verify Account"
                  style={{ width: "40px", height: "40px" }}
                />
              </div>
              <div>
                <h2 className="mb-2" style={{ fontSize: '16px', fontWeight: 'bold' }}>Please Verify Your Account</h2>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>To access all the features of our platform, Please verify your account.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Verification Pending Card for VerificationPending Users */}
      {user?.user_role === "User" && user?.profile_status === "VerificationPending" && (
        <div className="row justify-content-center">
          <div className="col-sm-6 col-lg-4 col-xl-4 mb-4 d-flex">
            <div className="mainbox w-100 text-center">
              <div className="icon mb-2">
                <img
                  src={pendingIcon}
                  alt="Verification Pending"
                  style={{ width: "30px", height: "30px" }}
                />
              </div>
              <div>
                <h2 className="mb-2" style={{ fontSize: '16px', fontWeight: 'bold' }}>Verification Pending</h2>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>Your account verification is in progress. You'll be notified once approved.</p>
              </div>
            </div>
          </div>
        </div>
      )}
 
      {/* GST Verification Pending Card for GSTUpdatePending Users */}
      {user?.user_role === "User" && user?.profile_status === "GSTUpdatePending" && (
        <div className="row justify-content-center">
          <div className="col-sm-6 col-lg-4 col-xl-4 mb-4 d-flex">
            <div className="mainbox w-100 text-center">
              <div className="icon mb-2">
                <img
                  src={pendingIcon}
                  alt="GST Verification Pending"
                  style={{ width: "30px", height: "30px" }}
                />
              </div>
              <div>
                <h2 className="mb-2" style={{ fontSize: '16px', fontWeight: 'bold' }}>GST Verification Pending</h2>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>Your GST verification is in progress. You’ll be notified once approved.</p>
              </div>
            </div>
          </div>
        </div>
      )}

 
      {/* Verification Rejected Card for RequestRejected Users */}
      {user?.user_role === "User" && user?.profile_status === "RequestRejected" && (
        <div className="row justify-content-center">
          <div className="col-sm-6 col-lg-4 col-xl-4 mb-4 d-flex">
            <div
              className="mainbox w-100 text-center"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/user-profile")}
            >
              <div className="icon mb-2">
                <CancelIcon style={{ fontSize: "40px", color: "red" }} />
              </div>
              <div>
                <h2 className="mb-2" style={{ fontSize: '16px', fontWeight: 'bold' }}>Verification Rejected</h2>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>Please reupload the correct document and detail.</p>
              </div>
            </div>
          </div>
        </div>
      )}
 
      {/* Verification Rejected Card for VerificationRejected Users */}
      {user?.user_role === "User" && user?.profile_status === "VerificationRejected" && (
        <div className="row justify-content-center">
          <div className="col-sm-6 col-lg-4 col-xl-4 mb-4 d-flex">
            <div
              className="mainbox w-100 text-center"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/user-profile")}
            >
              <div className="icon mb-2">
                <CancelIcon style={{ fontSize: "40px", color: "red" }} />
              </div>
              <div>
                <h2 className="mb-2" style={{ fontSize: '16px', fontWeight: 'bold' }}>Verification Rejected</h2>
                <p style={{ fontSize: '12px', fontWeight: '500' }}>Please reupload the correct document and detail.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Dashboard;